import React, { useEffect, useMemo, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Link, useNavigate } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { fetchAllCategories } from '../services/category-service';
import { FaPencilAlt, FaTrashAlt } from 'react-icons/fa';

const stockDData = [
  { name: 'Cherry Delight', productId: '#AP012740', price: '$95.00', quantity: '350 pcs', type: 'Dessert', status: 'Pending' },
  { name: 'Kiwi', productId: '#AP012741', price: '$22.00', quantity: '670 kg', type: 'Fruits', status: 'Active' },
  { name: 'Mango Magic', productId: '#AP012742', price: '$35.00', quantity: '200 pcs', type: 'Ice Cream', status: 'Inactive' },
  { name: 'Olive Oil', productId: '#AP012743', price: '$18.00', quantity: '400 ml', type: 'Oil', status: 'On Sale' },
  { name: 'Cinna Buns', productId: '#AP012744', price: '$15.00', quantity: '120 pcs', type: 'Breads', status: 'Active' },
  { name: 'Cinna Buns', productId: '#AP012744', price: '$15.00', quantity: '120 pcs', type: 'Breads', status: 'Active' },
  { name: 'Cinna Buns', productId: '#AP012744', price: '$15.00', quantity: '120 pcs', type: 'Breads', status: 'Active' },
  { name: 'Cinna Buns', productId: '#AP012744', price: '$15.00', quantity: '120 pcs', type: 'Breads', status: 'Active' },
  { name: 'Cinna Buns', productId: '#AP012744', price: '$15.00', quantity: '120 pcs', type: 'Breads', status: 'Active' },
  { name: 'Cinna Buns', productId: '#AP012744', price: '$15.00', quantity: '120 pcs', type: 'Breads', status: 'Active' },
  { name: 'Cinna Buns', productId: '#AP012744', price: '$15.00', quantity: '120 pcs', type: 'Breads', status: 'Active' },
  { name: 'Cinna Buns', productId: '#AP012744', price: '$15.00', quantity: '120 pcs', type: 'Breads', status: 'Active' },
  { name: 'Cinna Buns', productId: '#AP012744', price: '$15.00', quantity: '120 pcs', type: 'Breads', status: 'Active' },
  { name: 'Cinna Buns', productId: '#AP012744', price: '$15.00', quantity: '120 pcs', type: 'Breads', status: 'Active' },
  { name: 'Cinna Buns', productId: '#AP012744', price: '$15.00', quantity: '120 pcs', type: 'Breads', status: 'Active' },
  { name: 'Cinna Buns', productId: '#AP012744', price: '$15.00', quantity: '120 pcs', type: 'Breads', status: 'Active' },
  { name: 'Cinna Buns', productId: '#AP012744', price: '$15.00', quantity: '120 pcs', type: 'Breads', status: 'Active' },
  { name: 'Cinna Buns', productId: '#AP012744', price: '$15.00', quantity: '120 pcs', type: 'Breads', status: 'Active' },
  { name: 'Cinna Buns', productId: '#AP012744', price: '$15.00', quantity: '120 pcs', type: 'Breads', status: 'Active' },
  { name: 'Cinna Buns', productId: '#AP012744', price: '$15.00', quantity: '120 pcs', type: 'Breads', status: 'Active' },
];

const statusColors = {
  Pending: 'bg-yellow-200 text-yellow-800',
  Active: 'bg-green-200 text-green-800',
  Inactive: 'bg-red-200 text-red-800',
  'On Sale': 'bg-blue-200 text-blue-800',
};

const PurchaseReport = () => {
  const navigate = useNavigate()
  const [search, setSearch] = useState('');
  const [statusFilter, setStatusFilter] = useState('');
  const { data: stockData, isLoading, error } = useQuery({
    queryKey: ['/category/categories'],
    queryFn: fetchAllCategories,
  });
  
   useEffect(() => {
        const handleKeyDown = (e) => {
          if (e.ctrlKey && e.key.toLowerCase() === "n") {
            e.preventDefault(); // optional
            navigate("/masters/category-master-list/new-category"); // go back one step in history
          }
        };
    
        window.addEventListener("keydown", handleKeyDown);
        return () => window.removeEventListener("keydown", handleKeyDown);
      }, [navigate]);
 
  const filteredData = useMemo(()=>{
    return stockData?.filter((item) =>
    item.name.toLowerCase().includes(search.toLowerCase()) &&
    (statusFilter ? item.status === statusFilter : true)
  )},[stockData,statusFilter,search]);

  return (
    <div className="bg-white shadow-md rounded-xl">
      {/* Header and Filters */}
      <div className="flex flex-wrap justify-between items-center px-4 py-3 bg-[#9481ce] rounded-t-xl text-white">
        <h2 className="text-lg font-semibold">Purchase Report</h2>
        <div className="flex flex-wrap items-center gap-3">
          <input
            type="text"
            placeholder="Search product..."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            className="px-3 py-1 rounded-md text-sm text-gray-800 focus:outline-none"
          />
          <select
            value={statusFilter}
            onChange={(e) => setStatusFilter(e.target.value)}
            className="px-3 py-1 rounded-md text-sm text-gray-800"
          >
            <option value="">All Status</option>
            <option value="Pending">Pending</option>
            <option value="Active">Active</option>
            <option value="Inactive">Inactive</option>
            <option value="On Sale">On Sale</option>
          </select>
          <Link  to={"/masters/category-master-list/new-category"} className="bg-white text-[#9481ce] px-4 py-1.5 rounded-md text-sm font-medium hover:bg-violet-100">
            + Add New
          </Link>
        </div>
      </div>

      {/* Table */}
      <div className="overflow-x-auto max-h-[calc(100vh-170px)] overflow-y-auto">
        <table className="min-w-full text-sm text-left">
          <thead className="bg-[#e6e1f5] text-[#4b3d91] uppercase text-xs sticky top-0 z-10">
            <tr>
              <th className="px-4 py-3">Category Id</th>
              <th className="px-4 py-3">Category Name</th>
              <th className="px-4 py-3">Short Name</th>
              <th className="px-4 py-3">Slug</th>
              <th className="px-4 py-3">HSN Code</th>
              <th className="px-4 py-3">Description</th>
          
            </tr>
          </thead>
          <tbody className="bg-white text-gray-700">
            <AnimatePresence>
              {filteredData?.length ? filteredData?.map((item, index) => (
                <motion.tr
                  key={item.productId}
                  initial={{ opacity: 0, y: 10 }}
                  animate={{ opacity: 1, y: 0 }}
                  exit={{ opacity: 0, y: -10 }}
                  transition={{ duration: 0.25, delay: index * 0.03 }}
                  className="border-t hover:bg-[#f4f0ff] transition"
                >
                  <td className="px-4 py-2 font-medium">{item.id}</td>
                  <td className="px-4 py-2">{item.name}</td>
                  <td className="px-4 py-2">{item.shortname}</td>
                  <td className="px-4 py-2">{item.slug}</td>
                  <td className="px-4 py-2">{item.hsn}</td>
                  <td className="px-4 py-2">{item.description}</td>
                 
                   
                </motion.tr>
              )):""}

              {filteredData?.length === 0 && (
                <motion.tr
                  initial={{ opacity: 0 }}
                  animate={{ opacity: 1 }}
                  exit={{ opacity: 0 }}
                >
                  <td colSpan="7" className="text-center text-gray-500 py-6">
                    No matching records found.
                  </td>
                </motion.tr>
              )}
            </AnimatePresence>
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default PurchaseReport;
